import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, PopoverController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { TypeopenPage } from '../typeopen/typeopen';
import { QuickviewPage } from '../quickview/quickview';

@Component({
  selector: 'page-fenstertyp',
  templateUrl: 'fenstertyp.html',
})
export class FenstertypPage {
productname: string;
producttype: string;
windowtype: string;
myChoice: any;
 
  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public popoverCtrl: PopoverController) {
  
    this.productname = this.navParams.get('productname');
    this.producttype = this.navParams.get('producttype');
    console.log( this.productname, this.producttype); 
  
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FenstertypPage');
  }
  
    ionViewWillEnter() : void
   {
    this.getProductTypes();
   }
   
    clicktype(windowtype) {
    this.navCtrl.push(TypeopenPage, {
    windowtype: windowtype,
    productname: this.productname,
    producttype: this.producttype
    });
  }
  
    presentQuickView() {
    this.myChoice = {productname: this.productname, producttype :this.producttype}
    const popover = this.popoverCtrl.create(QuickviewPage, this.myChoice, {cssClass: 'popover-top-right'});
    popover.present();
  } 
  
   
     getProductTypes(){
  this.presentLoading();
  this.userService.getProductTypes().subscribe((data : any) =>
      {
          this.types = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });
        }
        
     presentLoading() {
        this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
        });
        this.loading.present();
    }
   
   
   doRefresh(refresher) {
   this.getProductTypes();
   refresher.complete();
   }

}



// WEBPACK FOOTER //
// ./src/pages/fenstertyp/fenstertyp.ts